import React, { Component } from "react";
import AngleLeftIcon from "react-icons/lib/fa/angle-left";
import AngleRightIcon from "react-icons/lib/fa/angle-right";

import {
  Pagination as BootstrapPagination,
  PaginationLink,
  PaginationItem
} from "reactstrap";

class Pagination extends Component {
  setPage = page => {
    const { setPage } = this.props;
    setPage({ page });
  };

  render() {
    const { numberOfPages, currentPage } = this.props;
    let { maxPagesDisplay } = this.props;

    let withDots = true;
    if (maxPagesDisplay >= numberOfPages) {
      withDots = false;
    }
    if (maxPagesDisplay > numberOfPages) {
      maxPagesDisplay = numberOfPages;
    }

    let items = [];

    let i =
      currentPage - parseInt(maxPagesDisplay / 2, 10) < 1
        ? 1
        : currentPage + parseInt(maxPagesDisplay / 2, 10) > numberOfPages
          ? numberOfPages - maxPagesDisplay + 1
          : currentPage - parseInt(maxPagesDisplay / 2, 10);

    const limit = i + maxPagesDisplay;

    for (i; i < limit; i++) {
      items.push(
        <PaginationItem
          key={i}
          active={i === currentPage}
          onClick={this.setPage.bind(this, i)}
        >
          <PaginationLink>{i}</PaginationLink>
        </PaginationItem>
      );
    }

    const first = withDots ? maxPagesDisplay >
    numberOfPages ? null : currentPage - parseInt(maxPagesDisplay / 2, 10) >
    1 ? (
      <PaginationItem
        active={1 === currentPage}
        onClick={this.setPage.bind(this, 1)}
      >
        <PaginationLink>{1}</PaginationLink>
      </PaginationItem>
    ) : null : null;
    const last = withDots ? maxPagesDisplay >
    numberOfPages ? null : currentPage <
    numberOfPages - parseInt(maxPagesDisplay / 2, 10) ? (
      <PaginationItem
        active={numberOfPages === currentPage}
        onClick={this.setPage.bind(this, numberOfPages)}
      >
        <PaginationLink>{numberOfPages}</PaginationLink>
      </PaginationItem>
    ) : null : null;

    if (first !== null) {
      items.shift();
    }

    if (last !== null) {
      items.pop();
    }

    const prev = (
      <PaginationItem
        disabled={currentPage === 1}
        onClick={
          currentPage !== 1 ? this.setPage.bind(this, currentPage - 1) : null
        }
      >
        <PaginationLink>
          <AngleLeftIcon size="14" />
        </PaginationLink>
      </PaginationItem>
    );

    const next = (
      <PaginationItem
        disabled={currentPage === numberOfPages}
        onClick={
          currentPage !== numberOfPages ? (
            this.setPage.bind(this, currentPage + 1)
          ) : null
        }
      >
        <PaginationLink>
          <AngleRightIcon size="14" />
        </PaginationLink>
      </PaginationItem>
    );

    if (numberOfPages > 1) {
      return (
        <BootstrapPagination>
          {currentPage !== 1 && prev}
          {first}
          {first !== null ? (
            <PaginationItem disabled>
              <PaginationLink>...</PaginationLink>
            </PaginationItem>
          ) : null}
          {items}
          {last !== null ? (
            <PaginationItem disabled>
              <PaginationLink>...</PaginationLink>
            </PaginationItem>
          ) : null}
          {last}
          {currentPage !== numberOfPages && next}
        </BootstrapPagination>
      );
    } else {
      return <div />;
    }
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Table/Pagination.js